import { Image } from "antd";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "../../../../components";
import { envChangeType } from "../../../../plugins/utils";
import { eighteen, gc, gli, mga, pagcor, safe } from "../../icons/brands";
import FairRulesPopup from "../FairRulesPopup";
import styles from "./styleModule";

const FairRules = ({ showGuideline = true }) => {
  const { t } = useTranslation();
  const [popupData, setPopupData] = useState();
  const [visible, setVisible] = useState(false);

  const data = {
    legal: {
      title: t("home.fairRules.legal"),
      subTitle: t("home.fairRules.legal.subTitle"),
      content: t("home.fairRules.legal.content"),
    },
    fair: {
      title: t("home.fairRules.fair"),
      subTitle: t("home.fairRules.fair.subTitle"),
      content: t("home.fairRules.fair.content"),
    },
  };

  const brands = [
    { src: eighteen, name: "eighteen" },
    { src: safe, name: "safe" },
    { src: mga, name: "mga" },
    { src: pagcor, name: "pagcor" },
    { src: gli, name: "gli" },
    { src: gc, name: "gc" },
  ];

  return (
    <div className={`${styles.container}`}>
      {showGuideline ? (
        <div className={styles.buttons}>
          {Object.keys(data).map((item) => {
            return (
              <Button
                type="text"
                className={styles.button}
                onClick={() => {
                  setVisible(true);
                  setPopupData(data[item]);
                }}
              >
                {data[item].title}
              </Button>
            );
          })}
        </div>
      ) : null}
      <div className={styles.brands}>
        {brands.map((brand) => {
          return (
            <Image src={brand.src} alt={brand.name} key={brand.name} preview={false} height={18} />
          );
        })}
      </div>
      <div className={styles.warning}>
        {t(
          [
            `home.fairRules.${envChangeType("REACT_APP_PRODUCTION_NAME_DEV")}.text`,
            "home.fairRules.text",
          ],
          {
            name: envChangeType("REACT_APP_PRODUCTION_NAME_DISPLAY"),
          },
        )}
      </div>
      <FairRulesPopup
        visible={visible}
        onClose={() => {
          setVisible(false);
        }}
        content={() => {}}
        data={popupData}
      />
    </div>
  );
};

export default FairRules;
